export default __webpack_public_path__ + "static/media/NIE_touchpoint_02.4ce9145e.mp4";